import { call, put, takeLatest } from 'typed-redux-saga'
import { MODAL_NAME } from 'Constants/ModalName'
import {
	getErrorsNotifications,
	showError,
	modalsSlice,
	ErrorCode,
	ResponseError,
	EmailModal,
	EmailNS,
	emailSlice,
	emailApi,
	postEmailConfirmation,
	loadersSlice,
	EmailConfirmationCookie,
} from 'Modules'
import { Deserialize } from 'cerialize'
import { MODAL_SIZE } from 'Constants/Global'
import { isErrorBizon } from 'Helpers'

const defaultModalProps = {
	key: MODAL_NAME.EMAIL,
	Component: EmailModal,
	width: MODAL_SIZE.XS,
	title: 'Подтвердите код email',
}

function* emailErrorHandler(e: ResponseError) {
	yield* put(loadersSlice.actions.showGlobalLoader())
	if (e.status === ErrorCode.e403) return
	yield* call(showError, getErrorsNotifications(Deserialize(e, ResponseError))[0])
}

function* sendEmail(scope: string) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(postEmailConfirmation, scope)
	} catch (e) {
		yield* call(emailErrorHandler, e)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* sendConfirmEmail(action: EmailNS.SendConfirmEmail) {
	try {
		const { url, callback, params } = action.payload
		yield* put(loadersSlice.actions.showGlobalLoader())
		const code = EmailConfirmationCookie.getCode()
		if (code) {
			const res = yield* call(emailApi, url, code, params)
			callback(res)
		} else {
			yield* put(
				modalsSlice.actions.showModal({
					...defaultModalProps,
					componentProps: action.payload,
				})
			)
		}
	} catch (e) {
		yield* put(
			modalsSlice.actions.showModal({
				...defaultModalProps,
				componentProps: action.payload,
			})
		)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* confirmEmail(action: EmailNS.ConfirmEmail) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { url, code, callback, params } = action.payload
		const res = yield* call(emailApi, url, code, params)
		EmailConfirmationCookie.setCode(code)
		yield* put(emailSlice.actions.setCodeEmail({ url, code }))
		yield* put(modalsSlice.actions.hideModal(MODAL_NAME.EMAIL))
		callback?.(res)
	} catch (e) {
		yield* call(emailErrorHandler, e)
		const { errorCallback } = action.payload
		errorCallback?.(e)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* initConfirmEmail(action: EmailNS.InitConfirmEmail) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { url, params } = action.payload
		const code = EmailConfirmationCookie.getCode()
		yield* call(emailApi, url, code, params)
	} catch (e) {
		yield* call(emailErrorHandler, e)
		const scope = e.data?.errors[0]?.email_confirmation_code
		const { errorCallback } = action.payload
		if (isErrorBizon(e)) {
			errorCallback?.(e)
		} else {
			yield* call(sendEmail, scope)
		}
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* emailSaga() {
	yield* takeLatest(emailSlice.actions.initConfirmEmail.type, initConfirmEmail)
	yield* takeLatest(emailSlice.actions.confirmEmail.type, confirmEmail)
	yield* takeLatest(emailSlice.actions.sendConfirmEmail.type, sendConfirmEmail)
}
